"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartEndDateTime = void 0;
const react_1 = __importDefault(require("react"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const formik_1 = require("formik");
const core_1 = require("@material-ui/core");
const FDateTimeTextField_1 = require("./FDateTimeTextField");
function StartEndDateTime({ startDateField = 'startTime', endDateField = 'endTime', startLabel = 'Start time', endLabel = 'End time', onChangeEnd, onChangeStart, }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Grid_1.default, { item: true, xs: 6 },
            react_1.default.createElement(core_1.Box, { px: 1 },
                react_1.default.createElement(formik_1.Field, { component: FDateTimeTextField_1.FDateTimeField, name: startDateField, label: startLabel, fullWidth: true, onChange: onChangeStart }))),
        react_1.default.createElement(Grid_1.default, { item: true, xs: 6 },
            react_1.default.createElement(core_1.Box, { px: 1 },
                react_1.default.createElement(formik_1.Field, { component: FDateTimeTextField_1.FDateTimeField, name: endDateField, label: endLabel, fullWidth: true, onChange: onChangeEnd })))));
}
exports.StartEndDateTime = StartEndDateTime;
